import { Plus } from "lucide-react";

/**
 * "NOVO PEDIDO" em pílula, flutuando por cima das colunas — elas são o
 * protagonista da página, o botão não ocupa faixa própria (pedido do dono,
 * 22/09/2026). Quem usa decide a posição via `className`.
 */
export default function BotaoNovoPedido({ onClick, className = "" }) {
  return (
    <div className={className}>
      <button
        type="button"
        onClick={onClick}
        className="h-11 px-6 rounded-full bg-primary text-primary-foreground text-sm font-bold tracking-wide shadow-lg shadow-primary/30 flex items-center gap-2 hover:bg-primary/90 hover:scale-[1.03] active:scale-95 transition-transform focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background"
      >
        <Plus className="w-4 h-4" strokeWidth={2.5} />
        NOVO PEDIDO
      </button>
    </div>
  );
}
